import { SelectInput, TextInput } from "react-admin";
import { useFormContext } from "react-hook-form";
import { Col, Row } from "./grid.component";
import { Text } from "../components/typography.component";
import states from "../data/states.json";
import { getAddressByCep } from "../utils/getAddress.util";
import { formatCep } from "../utils/mask.util";
import { getDigits } from "../utils/getDigits.util";
import { regexs } from "../utils/regexs.util";

const validateCep = (value: string) => {
  if (!value) return undefined;
  const formatted = formatCep(value);
  return regexs.CEP_REGEX.test(formatted) ? undefined : "CEP Inválido";
};

export const AddressInputs = () => {
  const { setValue } = useFormContext();

  const handleGetAddress = async (cep: string) => {
    try {
      const response = await getAddressByCep(cep);
      setValue("address.street", response.data.logradouro);
      setValue("address.city", response.data.localidade);
      setValue("address.neighborhood", response.data.bairro);
      setValue("address.state", response.data.uf);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Text variant="subtitle1" display="block">
        Endereço
      </Text>
      <Row spacing={4}>
        <Col sm={3}>
          <TextInput
            fullWidth
            source="address.cep"
            label="CEP"
            defaultValue=""
            parse={(value: string) => getDigits(value)}
            format={(value: string) => (value ? formatCep(value) : value)}
            validate={validateCep}
            onChange={(event) => {
              const digitsOnly = getDigits(event.target.value);
              if (digitsOnly.length === 8) {
                handleGetAddress(digitsOnly);
              }
            }}
          />
        </Col>

        <Col sm={5}>
          <TextInput fullWidth source="address.street" label="Rua" />
        </Col>
        <Col sm={1}>
          <TextInput fullWidth source="address.number" label="Número" />
        </Col>
        <Col sm={3}>
          <TextInput fullWidth source="address.complement" label="Complemento" />
        </Col>
      </Row>
      <Row spacing={4}>
        <Col sm={4}>
          <TextInput fullWidth source="address.city" label="Cidade" />
        </Col>
        <Col sm={4}>
          <TextInput fullWidth source="address.neighborhood" label="Bairro" />
        </Col>
        <Col sm={2}>
          <SelectInput
            label="Estado"
            source="address.state"
            choices={states.map((state) => ({
              id: state.uf,
              name: state.uf.toUpperCase(),
            }))}
            fullWidth
            style={{ minWidth: "100%" }}
          />
        </Col>
        <Col sm={2}>
          <TextInput fullWidth source="address.country" label="País" defaultValue="Brasil" />
        </Col>
      </Row>
    </>
  );
};
